import { Injectable } from '@angular/core';
import { appInjector } from '../app-injector';
import { DataCollectionService } from '../data-collection';

@Injectable({ providedIn: 'root' })
export class EventControlUtility {
    /**
     * Collect data from events that are stopped from propagating
     *
     * @param enableDataCollection it is false by default
     * @param preventDefault it is false by default
     */
    static stopPropagationAndCollectData(
        e: Event,
        enableDataCollection = false,
        preventDefault = false
    ) {
        const dataCollectionService = appInjector().get(DataCollectionService);

        if (enableDataCollection) {
            dataCollectionService.handleClickEvent(e);
        }

        if (preventDefault) {
            e.preventDefault();
        }
        e.stopPropagation();
    }
}
